import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { LoaderService } from 'src/app/core/_config/loader.service';
import { YesOrNoComponent } from 'src/app/dialog/yes-or-no/yes-or-no.component';

@Component({
    selector: 'select-billet',
    templateUrl: './select-billet.component.html',
    styleUrls: ['./select-billet.component.scss'],
})
export class DialogSelectBilletComponent implements OnInit {
    billets = [];
    json = { Amount: 0 };
    selectedBillets: Set<any> = new Set();
    selectedSum: number = 0;
    selectedSumDisponible: number = 0;
    groupedBillets: { [key: string]: any[] } = {};
    collapseStates: { [key: string]: boolean } = {};

    constructor(
        private notificationsService: NotificationsService,
        public _loaderService: LoaderService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<DialogSelectBilletComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.billets = data.dataList;
        this.json = data.json;
    }

    ngOnInit(): void {
        this.groupBillets();
        this.selectedSumDisponible = this.json.Amount;
    }

    toggleSelectLine(billet: any) {
        if (this.selectedBillets.has(billet)) {
            this.selectedBillets.delete(billet);
            this.selectedSum -= billet.billetValue;
            this.selectedSumDisponible += billet.billetValue;
        } else {
            if (this.selectedSumDisponible <= 0) {
                this.notificationsService.warn('Valor total do boleto já foi selecionado');
                return;
            }

            this.selectedBillets.add(billet);
            this.selectedSum += billet.billetValue;
            this.selectedSumDisponible -= billet.billetValue;
        }

        if (this.selectedSumDisponible < 0) this.selectedSumDisponible = 0;
    }

    isSelected(billet: any): boolean {
        return this.selectedBillets.has(billet);
    }

    groupBillets() {
        this.groupedBillets = this.billets.reduce((groups, billet) => {
            const groupKey = billet.contractDescription;
            if (!groups[groupKey]) {
                groups[groupKey] = [];
                this.collapseStates[groupKey] = true; // inicia colapsado
            }
            groups[groupKey].push(billet);
            return groups;
        }, {});
    }

    toggleCollapse(groupKey: string) {
        this.collapseStates[groupKey] = !this.collapseStates[groupKey];
    }

    doneSelectBillets() {
        let allSelected = [...this.selectedBillets];
        if (allSelected.length == 0) {
            this.notificationsService.warn('Selecione uma parcelar');
            return;
        }
        let allNumber = allSelected.map((v) => v.number);

        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = 260;
        dialogConfig.data = {
            title: 'Confirmação',
            text: `Alterar para parcela(s) ${allNumber.join(' / ')}?`,
        };
        const popupConfirmation = this.dialog.open(YesOrNoComponent, dialogConfig);

        popupConfirmation.afterClosed().subscribe((result) => {
            if (result == undefined) {
                return;
            }
            if (result) this.dialogRef.close(allSelected);
        });
    }
    get groupedKeys() {
        return Object.keys(this.groupedBillets);
    }
}
